import React, { useState } from 'react';
import { LayoutChangeEvent, View } from 'react-native';
import LandingImage from 'assets/landing.jpg';
import styled from 'styled-components/native';
import { HeroImageContainer } from '../style';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import { BottomClip } from 'src/components';

const HeroImage = () => {
  const { colors } = useAppTheme();
  const [bottomClipWidth, setBottomClipWidth] = useState<number>();

  const onLayout = (event: LayoutChangeEvent) => {
    setBottomClipWidth(event.nativeEvent.layout.width);
  };

  return (
    <View onLayout={onLayout}>
      <HeroImageContainer source={LandingImage} />
      <BottomClipContainer>
        <BottomClip width={bottomClipWidth} color={colors.surface} />
      </BottomClipContainer>
    </View>
  );
};

export default HeroImage;

const BottomClipContainer = styled.View`
  position: absolute;
  bottom: 0;
`;
